/** Holds Clerk getToken so non-React api.js can attach Bearer tokens. */
let getTokenFn = null;

export function setClerkTokenGetter(fn) {
  getTokenFn = fn;
}

export async function getAuthToken() {
  if (getTokenFn) {
    try {
      const token = await getTokenFn();
      if (token) return token;
    } catch {
      /* fall through */
    }
  }
  return localStorage.getItem("token");
}
